import React from 'react'
import {
    Link,
  } from "react-router-dom";

export const Inventory = (props) => {
    return (
        <div>
            <div className="container">

                <h3 className="mt-4 mb-3" style={{fontFamily: 'effraReg'}}>BronzeTag Inventory Management
            
                </h3>

                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item active" style={{fontFamily: 'effraReg'}}>Inventory Management</li>
                </ol>

                <div className="row">
                    <div class="col-lg-12">
                        <p style={{fontFamily: 'effraReg'}}>Manage your vendors, purchase orders and returns. Track your vendor balances and payments all in one place.</p>
                    </div>
                
                </div>

                <div className="row">
                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', paddingLeft: 64}}>
                        <span style={{fontFamily: 'effraReg'}}>Multiple inventory locations.</span>
                        <span style={{fontFamily: 'effraReg'}}>Inventory sheets.</span>
                        <span style={{fontFamily: 'effraReg'}}>Inventory shortage reports.</span>
                        <span style={{fontFamily: 'effraReg'}}>Low inventory alerts.</span>
                        <span style={{fontFamily: 'effraReg'}}>Inventory damage tracking.</span>
                        
                    </div>
                    
                </div>
            
            </div>
        </div>
    )
}